<template>
  <div class="service-item">
    <i class="service-icon" :class="icon"></i>
    <h3>{{name}}</h3>
    <span>{{desc}}</span>
  </div>
</template>
<script>
  export default {
      props: {
          id: {
              type: Number,
              default: 0
          },
          icon: {
              type: String,
              required: true
          },
          name: {
              type: String,
              required: true
          },
          desc: {
              type: String,
              required: true
          }
      }
  };
</script>
<style lang="scss">
@import "./_common.scss";
.service-item {
  @extend .hover-item;
  text-align: center;
  cursor: pointer;
  & > h3 {
    line-height: 20px;
    text-align: center;
    color: #333d48;
    margin-top: 8px;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: normal;
  }
  & > span {
    display: block;
    font-size: 12px;
    text-align: center;
    color: #93999f;
    line-height: 17px;
  }
  .service-icon {
    display: inline-block;
    text-align: center;
    width: 85px;
    height: 85px;
    background-size: 85px 85px;
    background-repeat: no-repeat;
    &.zicu {
      background-image: url(https://p1.meituan.net/codeman/2c2fe0838a03b3b8d8042cc7e263249f18851.png);
      transform: translateX(2px);
    }
    &.app {
      background-image: url(https://p1.meituan.net/codeman/5331caad0eb0e6afb6bda22b4b6cc18421787.png);
      transform: translateX(6px);
    }
    &.comment {
      background-image: url(https://p0.meituan.net/codeman/8b89b750442c710dd3e884aa08f0c33115747.png);
      transform: translateX(2px);
    }
    &.datacenter {
      background-image: url(https://p1.meituan.net/codeman/bdea4b67264db919242e48a0e0d185eb18628.png);
    }
  }
}
</style>




// WEBPACK FOOTER //
// serviceItem.vue?4be1bf41